import Vue from 'vue';

function install(context, { engine, modules }) {

  context.on('componentregister', component => {
    let worker = component.worker;
    let builder = component.builder;
    // socket - Rete.Socket instance or function that returns a socket instance
    // let nodeType, socket;
    // if (component.module) {
    //   nodeType = component.module.nodeType;
    //   socket = component.module.socket;
    // }

    component.builder = async (...args) => {
      if (builder) {
        await builder.apply(component, args);
      }
      let [node] = args;
      this.node = node;
    };

    component.worker = async (...args) => {
      if (worker){
        await worker.apply(component, args);
      }

      let [node, inputs, outputs] = args;
      // Update Extract data global variable
      let exportData = {
        inputs,
        outputs,
        data: this.node.data,
        node: this.node,
      };

      Vue.prototype.$globalSharedData.extractData[node.id] = exportData;
    };
  });
}

export default {
    install
}
